import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Frame from '../components/Frame.tsx';
import Treemap from '../components/Treemap';
import shakespeare from '@vx/mock-data/lib/mocks/shakespeare';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "treemap"
    }}>{`Treemap`}</h1>
    <p>{`See the component `}<a parentName="p" {...{
        "href": "https://github.com/kristw/encodable/tree/master/packages/docs/src/components/Treemap"
      }}>{`source code`}</a>{`.
or play with the component API by editing the code below.`}</p>

    <Playground __position={0} __code={'<Frame width={360} height={270} background=\"#606060\">\n  <Treemap\n    width={360}\n    height={270}\n    padding={{ top: 20, bottom: 20, left: 20, right: 20 }}\n    // squarify, dice, slice, slice-dice, resquarify, binary\n    tileMethod=\"squarify\"\n    encoding={{\n      color: {\n        type: \'quantitative\',\n        field: \'size\',\n        scale: { type: \'linear\', range: [\'#606060\', \'#A8C96B\'] },\n      },\n      label: { field: \'id\' },\n      size: { type: \'quantitative\', field: \'size\' },\n    }}\n    data={shakespeare}\n  />\n</Frame>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Frame,
      Treemap,
      shakespeare,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Frame width={360} height={270} background="#606060" mdxType="Frame">
    <Treemap width={360} height={270} padding={{
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        }} // squarify, dice, slice, slice-dice, resquarify, binary
        tileMethod="squarify" encoding={{
          color: {
            type: 'quantitative',
            field: 'size',
            scale: {
              type: 'linear',
              range: ['#606060', '#A8C96B']
            }
          },
          label: {
            field: 'id'
          },
          size: {
            type: 'quantitative',
            field: 'size'
          }
        }} data={shakespeare} mdxType="Treemap" />
  </Frame>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      